import api from "@/api.js";
import findEntries from "./findEntries/"
import actions from './actions/'
import sources from './sources'
import impact from './impact'
import articles from './articles'
import business from './business'

export default {
  namespaced: true,
  modules: {
    findEntries,
    actions,
    sources,
    impact,
    articles,
    business
  },
  state: {
    list: [],
    listLoading: false,
    selectedSolution: null,
    solutionsSourcesList: [],
    solutionsImpactList: [],
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedSolution(state, payload) {
      state.selectedSolution = payload
    },
    setSolutionsSourcesList(state, payload) {
      state.solutionsSourcesList = payload;
    },
    setSolutionsImpactList(state, payload) {
      state.solutionsImpactList = payload;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("solutions");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllBySourceID({ commit }, id) {
      commit('setListLoading', true);
      let list = await api.get('solutions/sources/bySourceID', { params: { id: id } })

      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllSolutionsSourcesBySolutionID({ commit }, solutions_id) {
      commit("setListLoading", true);
      let list = await api.get("solutionsSources/byID", {
        params: { id: solutions_id }
      });
      commit("setSolutionsSourcesList", list.data);
      commit("setListLoading", false);
    },
    async loadAllForGoal({ commit }, payload) {
      commit("setListLoading", true);
      let list = await api.get("solutions/forGoal", {
        params: { id: payload }
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadSolutionByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/byID", {
        params: { id: id }
      });
      commit("setSelectedSolution", list.data[0]);
      commit("setListLoading", false);
    },
    async loadSolutionsImpactBySolutionID({ commit }, id) {
      commit("setSolutionsImpactList", []);
      commit("setListLoading", true);
      let list = await api.get("solutions/impact/bySolutionsID", {
        params: { id: id }
      });
      commit("setSolutionsImpactList", list.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutions", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async newSolutionsImpact({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutionsImpact", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadSolutionsImpactBySolutionID", payload.solutions_id);
      return returnData;
    },
    async saveSolutionsImpact({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("solutionsImpact", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadSolutionsImpactBySolutionID", payload.solutions_id);
      return returnData;
    },
    async newSource({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutionsSources", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAllSolutionsSourcesBySolutionID", payload.solutions_id);
      return returnData;
    },
    async saveSource({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("solutionsSources", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAllSolutionsSourcesBySolutionID", payload.solutions_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      //Uploading Image
      if (payload.image) {
        let uploadImageResult = await api.post('solutions/uploadImage', {
          id: payload.id,
          imageData: payload.image.dataUrl
        })
        delete payload.image;
        if (uploadImageResult.data.Result == "Success") {
          payload.imageUrl = uploadImageResult.data.objectUrl;
        }
      }
      await api
        .put(`solutions`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedSolution(state) {
      return state.selectedSolution;
    },
    solutionsSourcesList(state) {
      return state.solutionsSourcesList;
    },
    solutionsImpactList(state) {
      return state.solutionsImpactList
    }
  }
};
